enum QsrAutomationsItemIdKey {
  ItemBiteId = 'item-bite-id',
  ItemBarcode = 'item-barcode',
}

export { QsrAutomationsItemIdKey };
